import axios from "axios";
import http from "../ http-common";
import { API_BASE_URL } from "../config";
import store  from "../store";
const getBaseurl= () => {
  const state = store.getState();
  return state.server?.BASE_URL 
};
const getApibaseurl = () => {
  const state = store.getState();
  console.log("kjhgfdsadfgh uytfyguyi ",state.server?.API_BASE_URL );
  return state.server?.API_BASE_URL 
};
class AuthService {
  async login(email, password) {
    var formData = new FormData();
    let config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "Access-Control-Allow-Headers": "*",
      },
    };
    return  axios.post(
      getApibaseurl() + "/admin/login_check",
      {
        username: email,
        password: password,
      },
      config
    );
  }

  me() {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/me`);
  }

  logout() {
    var API_BASE_URL = `${getApibaseurl()}/admin`;
    return http.get(`${API_BASE_URL}/logout`);
  }
}

export default new AuthService();
